import type { FaireProductEntity } from "../../entity_types/product";

export const p_4wqzuye8af: FaireProductEntity = {
  token: "p_4wqzuye8af",
  type: "product",
  name: "Dear Baby: A Pregnancy Prayer Journal & Memory Book for Moms",
  brandToken: "b_1kike1ew9i",
  brandName: "Duncan & Stone Paper Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/e911b2e9f29830db7214460324325b01748bd358d8272351a5f570860c1fa1bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55981e094d09626cffb0549d453a0c698f06d3871128a25db1f6d2ac9ec3c498.jpeg",
    "https://cdn.faire.com/fastly/93414300c6d3d8345cbc119cf2dfaa01c1f57b6732d107fc196d9207e16b33c6.jpeg",
    "https://cdn.faire.com/fastly/ff0e7f5271b9ee6a9c7eef1ba8a7c4502ee24ae3aabec56041f4a3706d9e92ae.jpeg",
    "https://cdn.faire.com/fastly/b1f97ac51734885db7236fde8b839c63dbb35a7462aea4855ea67d21666c1823.jpeg",
    "https://cdn.faire.com/fastly/89195fe1b5a4083adde721884cf1ac82d864220773cca21b4e96a39880050467.jpeg",
    "https://cdn.faire.com/fastly/b6f440759732e671036a03c1a563f8b321fc36ad6abd43f900d49145d700ed79.jpeg",
    "https://cdn.faire.com/fastly/3252ba4e43489ef5d80bc6a51180bfe6cbe9622c41d7a24ae8b42e073f46eba0.jpeg",
    "https://cdn.faire.com/fastly/a5baff415b6ceeced53c4c318a64c1fb8dd2872d430129de0d87f70290d9eb37.jpeg",
    "https://cdn.faire.com/fastly/d4c6ff3a0e88b4f6788f04665f2ec17243a8df517951b967b3a808b0de791514.jpeg",
    "https://cdn.faire.com/fastly/a14f310e87ac787901901bd674fdeda2428f93eec0f43091f657fbec8871f0d4.jpeg",
    "https://cdn.faire.com/fastly/cfd99a1a7c5d698ee1a363b47cf9cc65ee958f210fc3a7a366536cc954e21a83.png",
    "https://cdn.faire.com/fastly/bfe86a44d8ba3b7bfc9058294b8ecb55329bbcd692df6116c65f8133050e95f8.jpeg",
    "https://cdn.faire.com/fastly/b234d9d09d794e2f46a059bf04ef38fd068f0cb9d2ec5048dbf13a890afca955.jpeg",
    "https://cdn.faire.com/fastly/3fd7b19f6dad85f09b6fc0d33304e27270c971ae299a9578faa5059b108a2658.jpeg",
    "https://cdn.faire.com/fastly/26270f6da52eb7d7f6c116d93d4606d2422b91af3e935eb7b3a3c25edba305ea.jpeg",
    "https://cdn.faire.com/fastly/b2993a14b35d92674ad09ac2851b58b8d8dffabbdf2f301f02d4878b52a0309d.jpeg",
  ],
  priceDollars: 19.86,
  description:
    'A weekly prayer journal that prompts you to pray for your baby as they grow.\n\nThis keepsake memory book also includes special milestone pages to help you capture all your favorite moments throughout pregnancy.\n\nThis pregnancy prayer journal is a great baby keepsake for any mom. Each week of pregnancy has a page that describes your baby\'s development and gives a prompt (with scripture) to guide you in praying for your baby as they grow. This journal also includes many other milestone pages to help you always remember the little and big moments that happened during this special season.\n\nPAGES INCLUDED:\nIn addition to a two page-spread for every week of pregnancy, this journal includes the following pages:\n\n• Intro page for name of Mom and Baby\n• Pregnancy Reveal Details\n• Monthly "Bump Photo"\n• Monthly Pregnancy Updates (food aversions/cravings, milestones, body changes, etc.)\n• Choosing Your Name\n• Gender Prediction\n• Ultrasound details\n• Ultrasound Photos\n\nColors: Cream, Gray and Navy',
  tags: [],
  msrpDollars: 39.72,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:36.702Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
